<template>
  <div class="rules">
    <h2 class="rules__title">{{translate('ppValidationMustContain')}}</h2>
    <div>
      <div class="rules__rule">
        <i
          class="rules__rule-icon xs"
          :class="`icon-${errorType.length ? 'alert-circle' : 'ok-tick'} text-${errorType.length ? 'danger' : 'success'}`"
        ></i>
        <span>{{translate('rwValidationBetween')}}</span>
      </div>
      <div class="rules__rule">
        <i
          class="rules__rule-icon xs"
          :class="`icon-${errorType.containsNumber ? 'alert-circle' : 'ok-tick'} text-${errorType.containsNumber ? 'danger' : 'success'}`"
        ></i>
        <span>{{translate('rwValidationDigit')}}</span>
      </div>
      <div class="rules__rule">
        <i
          class="rules__rule-icon xs"
          :class="`icon-${errorType.containsUpperCase ? 'alert-circle' : 'ok-tick'} text-${errorType.containsUpperCase ? 'danger' : 'success'}`"
        ></i>
        <span>{{translate('rwValidationUppercase')}}</span>
      </div>
      <div class="rules__rule">
        <i
          class="xs rules__rule-icon"
          :class="`icon-${errorType.containsLowerCase ? 'alert-circle' : 'ok-tick'} text-${errorType.containsLowerCase ? 'danger' : 'success'}`"
        ></i>
        <span>{{translate('rwValidationLowercase')}}</span>
      </div>
      <div v-if="isFlagActive('private.password.special.character')" class="rules__rule">
        <i
          class="xs rules__rule-icon"
          :class="`icon-${errorType.containsSpecialCharacter ? 'alert-circle' : 'ok-tick'} text-${errorType.containsSpecialCharacter ? 'danger' : 'success'}`"
        ></i>
        <span>{{translate('rwValidationSpecialCharacter')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { isFlagActive } from '@/infrastructure/Configuration'

export default {
  name: 'PasswordValidationText',
  props: {
    errorType: Object
  },
  methods: {
    isFlagActive
  }
}
</script>

<style lang="scss">
.rules {
  &__title {
    margin: 1.2rem 0;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }

  &__rule {
    color: color('dark-grey');
    display: flex;
    align-items: center;
    column-gap: 0.8rem;

    &-icon {
      font-size: 1.8rem !important;
      width: 1.8rem !important;
      height: 1.8rem !important;
    }
  }
}
</style>
